module.exports = __webpack_public_path__ + "static/img/103461.a72e4086.png";